<template>
  <div>
    <MemberHeader />
    <router-view />
    <Cart v-model:visible="cartVisible" />
    <MemberFooter />
  </div>
</template>

<script>
import { ref } from 'vue';
import MemberHeader from '@/views/MemberHeader.vue';
import MemberFooter from '@/views/MemberFooter.vue';
import Cart from '@/components/productList/Cart.vue';

export default {
  name: 'MemberLayout',
  components: {
    MemberHeader,
    MemberFooter,
    Cart
  },
  setup() {
    const cartVisible = ref(false);
    return { cartVisible };
  }
}
</script>
